import { z } from 'zod';

export const ExerciseRecoveryActivitySchema = z.object({
    id: z.string().optional(),
    step: z.coerce.number().optional(),
    name: z.string().min(1),
    description: z.string().optional(),
    timeframe: z.string().optional(),
    owner: z.string().optional(),
    team: z.string().optional(),
    startDate: z.string().or(z.date()).optional(),
    endDate: z.string().or(z.date()).optional(),
    progress: z.coerce.number().min(0).max(100).optional(),
    dependencies: z.string().optional(),
    externalSupport: z.boolean().optional(),
    vendor: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateExerciseRecoveryActivitySchema = ExerciseRecoveryActivitySchema.omit({ id: true });
export const UpdateExerciseRecoveryActivitySchema = ExerciseRecoveryActivitySchema.partial();
